import { useEffect } from 'react';

export default function useHeaderHeightVar(selector = '#site-header') {
  useEffect(() => {
    const el = document.querySelector(selector);

    const updateVar = () => {
      const h = Math.ceil(el?.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty('--headerH', `${h}px`);
    };

    updateVar();

    const ro = el ? new ResizeObserver(updateVar) : null;
    ro?.observe(el);

    window.addEventListener('resize', updateVar);
    window.addEventListener('scroll', updateVar);

    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', updateVar);
      window.removeEventListener('scroll', updateVar);
    };
  }, [selector]);
}
